module.exports = __webpack_public_path__ + "static/img/7.ad2984a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/7.png
// module id = 69xn
// module chunks = 0